import React from "react";
import "./LocateBot.css";

const LocateBot = () => {
  return (
    <div className="bots-guide">
      <h1>Locating Your Bots</h1>
      <p>
        All chatbots you create can be accessed through your <strong>XenaChat Dashboard</strong> or the <strong>"Your Bots"</strong> section.
      </p>

      <h2>Access Your Bots via the Dashboard</h2>
      <ul>
        <li>Click <strong>[Home]</strong> from the left-hand navigation menu. Your bots are displayed in the lower section of the Dashboard.</li>
        <li>To view or modify a bot's configuration, simply click on the bot.</li>
        <li>Deleted bots can never be restored.</li>
      </ul>

      <h2>Manage Bots</h2>
      <p>
        To Manage your bots you need to simply click on that particular bot and can manage it.
      </p>
      <p>For detailed instructions, refer to <strong>Quick Start Guide Overview</strong>.</p>

    </div>
  );
};

export default LocateBot;
